import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';

@Component({
  selector: 'app-delete-dialog',
  standalone: true,
  imports: module,
  templateUrl: './delete-dialog.component.html',
  styleUrl: './delete-dialog.component.scss'
})
export class TwoLevelDeleteDialogComponent {
  public isLoading: boolean = false;
  public step: number = 1;

  constructor(private dialogRef: MatDialogRef<TwoLevelDeleteDialogComponent>) { }

  nextStep(): void {
    this.step = 2;
  }

  confirmDelete(): void {
    this.dialogRef.close(true);
  }
}
